import {
  booleanAttribute,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgbProgressbar } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-card",
  standalone: true,
  imports: [CommonModule, NgbProgressbar],
  templateUrl: "./card.component.html",
  styleUrl: "./card.component.scss",
})
export class CardComponent implements OnChanges {
  @Input({ required: true })
  cardObj: any;

  @Input()
  isTabChange: boolean = false;

  @Input({ required: true })
  showDetailCard: boolean = false;

  @Input({ required: true })
  showHoverCard: boolean = false;

  @Output() cardClick: EventEmitter<void> = new EventEmitter<void>();

  @Output() hoverIn: EventEmitter<void> = new EventEmitter<void>();

  @Output() hoverOut: EventEmitter<void> = new EventEmitter<void>();

  progressValue: number = 0;
  intervalId: any;
  timeoutId: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["showDetailCard"]?.currentValue) {
      this.startProgress(this.isTabChange);
    } else {
      clearInterval(this.intervalId);
      clearInterval(this.timeoutId);
      this.progressValue = 0;
    }
  }

  showConsultancyCard() {
    this.cardClick.emit();
    clearInterval(this.intervalId);
    clearInterval(this.timeoutId);
    if (this.showDetailCard) {
      this.startProgress(true);
    }
  }

  startProgress(clickEvent: boolean = false) {
    this.progressValue = 0;
    if (clickEvent) {
      this.timeoutId = setTimeout(() => {
        this.intervalId = this.intervalMethod(clickEvent);
      }, 500);
    } else {
      this.intervalId = this.intervalMethod(clickEvent);
    }
  }

  intervalMethod(clickEvent: boolean) {
    return setInterval(
      () => {
        this.progressValue += 1;
        if (this.progressValue >= 100) {
          clearInterval(this.intervalId);
        }
      },
      clickEvent ? 53.5 : 56.5
    );
  }
}
